import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EmpresaDto } from '@shared/service-proxies/service-proxies';



@Injectable({ providedIn: 'root' })

export class EmpresaService {

    private empresa: EmpresaDto;
    private empresaUpdated = new Subject<EmpresaDto>();

    getEmpresa() {
        return this.empresa;
    }

    getEmpresaUpdateListener() {
        return this.empresaUpdated.asObservable();
    }

    setEmpresa(empresa: EmpresaDto) {
        this.empresa = empresa;        
        this.empresaUpdated.next(this.empresa);
    }
}
